// Module
var code = "<div class=\"iia-title-text\">{{titleText}}</div> ";
// Exports
module.exports = code;